import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { jobsAPI } from '../utils/api';
import toast from 'react-hot-toast';
import './JobApplications.css';

const STATUS_LABELS = {
  pending: 'قيد المراجعة',
  reviewed: 'تمت المراجعة',
  shortlisted: 'قائمة الاختصار',
  interview: 'مقابلة',
  accepted: 'مقبول',
  rejected: 'مرفوض',
};

const STATUS_COLORS = {
  pending: 'badge-warning',
  reviewed: 'badge-info',
  shortlisted: 'badge-primary',
  interview: 'badge-accent',
  accepted: 'badge-success',
  rejected: 'badge-danger',
};

export default function JobApplications() {
  const { id } = useParams();
  const [applications, setApplications] = useState([]);
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    Promise.all([jobsAPI.getApplications(id), jobsAPI.getById(id)])
      .then(([apps, jobData]) => {
        setApplications(apps.data.data || []);
        setJob(jobData.data.data);
      })
      .catch(() => toast.error('فشل تحميل الطلبات'))
      .finally(() => setLoading(false));
  }, [id]);

  const updateStatus = async (appId, status) => {
    try {
      await jobsAPI.updateApplicationStatus(id, appId, { status });
      setApplications(prev => prev.map(a => a.id === appId ? { ...a, status } : a));
      toast.success('تم تحديث الحالة');
    } catch { toast.error('فشل التحديث'); }
  };

  const filtered = filter === 'all' ? applications : applications.filter(a => a.status === filter);

  if (loading) return <div className="page-loading"><div className="spinner"></div></div>;

  return (
    <div className="applications-page">
      <div className="apps-page-header">
        <div className="apps-header-content">
          <Link to={`/jobs/${id}`} className="back-link">← العودة للوظيفة</Link>
          <h1>طلبات {job?.title}</h1>
          <p>{applications.length} متقدم</p>
        </div>
      </div>

      <div className="apps-container">
        <div className="apps-filter-bar">
          {['all', ...Object.keys(STATUS_LABELS)].map(s => (
            <button key={s}
              className={`filter-chip ${filter === s ? 'active' : ''}`}
              onClick={() => setFilter(s)}>
              {s === 'all' ? 'الكل' : STATUS_LABELS[s]}
              <span className="chip-count">
                {s === 'all' ? applications.length : applications.filter(a => a.status === s).length}
              </span>
            </button>
          ))}
        </div>

        {filtered.length === 0 ? (
          <div className="empty-state">
            <span>📋</span>
            <h3>لا توجد طلبات بهذا الفلتر</h3>
          </div>
        ) : (
          <div className="apps-grid">
            {filtered.map(app => (
              <div key={app.id} className="app-card">
                <div className="app-card-top">
                  <div className="applicant-info">
                    {app.avatar ? (
                      <img src={`${process.env.REACT_APP_API_URL}/uploads/${app.avatar}`}
                        alt="" className="applicant-avatar" />
                    ) : (
                      <div className="applicant-avatar placeholder">{app.full_name?.[0]}</div>
                    )}
                    <div>
                      <Link to={`/profile/${app.applicant_uuid}`} className="applicant-name">
                        {app.full_name}
                      </Link>
                      <p className="applicant-title">{app.job_title || 'محترف رياضي'}</p>
                    </div>
                  </div>
                  <span className={`badge ${STATUS_COLORS[app.status]}`}>
                    {STATUS_LABELS[app.status]}
                  </span>
                </div>

                {app.cover_letter && (
                  <div className="cover-letter-preview">
                    <p>{app.cover_letter.slice(0, 200)}{app.cover_letter.length > 200 ? '...' : ''}</p>
                  </div>
                )}

                <div className="app-meta">
                  <span>📅 {new Date(app.created_at).toLocaleDateString('ar')}</span>
                  {app.resume_url && (
                    <a href={app.resume_url} target="_blank" rel="noreferrer" className="resume-link">
                      📄 السيرة الذاتية
                    </a>
                  )}
                </div>

                <div className="app-actions">
                  <select
                    className="status-select"
                    value={app.status}
                    onChange={e => updateStatus(app.id, e.target.value)}
                  >
                    {Object.entries(STATUS_LABELS).map(([val, label]) => (
                      <option key={val} value={val}>{label}</option>
                    ))}
                  </select>
                  <Link to={`/profile/${app.applicant_uuid}`} className="btn btn-outline btn-sm">
                    عرض الملف
                  </Link>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
